<script setup lang="ts">
import { computed, ref } from 'vue';
import { useReprDropZone } from '../composables/drag-controller';

const props = withDefaults(
    defineProps<{
        disabled?: boolean;
        severity?: 'danger' | 'warning' | 'success';
        path: number[];
    }>(),
    { severity: 'warning', dragController: null, parentRepr: null }
);

const zone = ref<HTMLDivElement>();

const { active, hovering } = useReprDropZone({
    boundingBox: () => zone.value?.getBoundingClientRect(),
    path: () => props.path,
    disabled: () => props.disabled,
});

const wrapperClass = computed(() => {
    const res: string[] = [`severity-${props.severity}`];

    if (active.value) res.push('drop-zone-active');
    if (hovering.value) res.push('drop-zone-hovering');

    return res;
});
</script>

<template>
    <div ref="zone" class="node-repr-drop-zone" :class="wrapperClass">
        <div class="node-repr-drop-zone-overlay"></div>
        <slot />
    </div>
</template>

<style lang="scss">
.node-repr-drop-zone {
    position: relative;

    .node-repr-drop-zone-overlay {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: 20;
        border-radius: var(--border-radius);
        border-width: 1px;
        border-style: none;
        display: none;
    }

    &.severity-warning {
        .node-repr-drop-zone-overlay {
            border-color: var(--yellow-500);
        }

        &.drop-zone-hovering {
            .node-repr-drop-zone-overlay {
                background-color: var(--yellow-500);
            }
        }
    }

    &.severity-danger {
        .node-repr-drop-zone-overlay {
            border-color: var(--red-500);
        }

        &.drop-zone-hovering {
            .node-repr-drop-zone-overlay {
                background-color: var(--red-500);
            }
        }
    }

    &.severity-success {
        .node-repr-drop-zone-overlay {
            border-color: var(--green-500);
        }

        &.drop-zone-hovering {
            .node-repr-drop-zone-overlay {
                background-color: var(--green-500);
            }
        }
    }

    &.drop-zone-active {
        .node-repr-drop-zone-overlay {
            display: block;
            border-style: solid;
        }
    }

    &.drop-zone-hovering {
        .node-repr-drop-zone-overlay {
            display: block;
            opacity: 50%;
        }
    }
}
</style>
